import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {

  constructor(private _auth: AuthService
    , private _http: HttpClient
    , private _environmentService: EnvironmentService) { }

  getPublicSessions = (studioIds: number[] = [], instructorIds: number[] = [], addressIds: number[] = [], locationId: number = 1, showPartners: boolean = false) => { 
    let studioIdParam = studioIds.join(',');
    let instructorIdParam = instructorIds.join(',');
    let addressIdParam = addressIds.join(',');
    if(studioIdParam == "")
      studioIdParam = " ";
    if(instructorIdParam == "")
      instructorIdParam = " ";
    if(addressIdParam == "")
      addressIdParam = " ";
    if(locationId == 0)
      locationId = 1;
    const partnerQuery = showPartners ? '?showPartners=true' : '';
    return this._http.get(`${this._environmentService.getFacilityConfig().facilityUrl}api/v1/Public/ClassSessions/${studioIdParam}/${instructorIdParam}/0/0/${addressIdParam}/${locationId}${partnerQuery}`);
  }

  fetchSession(sessionId: number) {
    if (this._auth.isLoggedIn()) {
      return this._http.get(`${this._environmentService.getFacilityConfig().facilityUrl}api/v1/Class/Course/Session/${sessionId}`);
    }
    return null;
  }

  fetchClass(classId: number) {
    if (this._auth.isLoggedIn()) {
      return this._http.get(`${this._environmentService.getFacilityConfig().facilityUrl}api/v1/Class/${classId}`);
    }
    return null;
  }
}
